import { useEffect, useState } from 'react';

import { ILegacyCartEntry } from '@rbi-ctg/menu';
import { useMainMenuContext } from 'state/menu/main-menu';
import { IDayPartBoundary } from 'state/menu/main-menu/types';
import { IMenuObjectWithDaypart, getMenuItemDayParts } from 'utils/availability';

import { useCartEntriesMenuObjects } from './use-cart-entries-menu-objects';

/**
 * Iterates over menu items and picks unique day parts
 */
const getAllMenuItemDayParts = (menuItems: IMenuObjectWithDaypart[]) =>
  menuItems.reduce((acc: string[], menuItem) => {
    const menuItemDayParts = getMenuItemDayParts(menuItem);
    return acc.concat(menuItemDayParts.filter(dayPart => !acc.includes(dayPart)));
  }, []);

export const useCartEntriesDayParts = (cartEntries: ILegacyCartEntry[] | undefined) => {
  const { activeDayParts } = useMainMenuContext();
  const { getCartEntriesMenuObjects } = useCartEntriesMenuObjects();

  const [isLoading, setIsLoading] = useState(true);
  const [cartEntriesDayParts, setCartEntriesDayParts] = useState<string[]>([]);
  const [cartEntriesActiveDayParts, setCartEntriesActiveDayParts] = useState<IDayPartBoundary[]>(
    []
  );

  useEffect(() => {
    if (!cartEntries) {
      return;
    }

    const fetchData = async () => {
      const data = await getCartEntriesMenuObjects(cartEntries);
      // FIXME: unsafe cast - Migrate to updated queries
      // @ts-ignore
      const menuItemsDayParts = getAllMenuItemDayParts(data.map(entry => entry.data));
      setCartEntriesDayParts(menuItemsDayParts);

      const menuItemsActiveDayParts = activeDayParts.filter(dayPart =>
        menuItemsDayParts.includes(dayPart.key.toLowerCase())
      );

      setCartEntriesActiveDayParts(menuItemsActiveDayParts);
      setIsLoading(false);
    };

    fetchData();
  }, [activeDayParts, cartEntries, getCartEntriesMenuObjects]);

  return {
    cartEntriesDayParts,
    cartEntriesActiveDayParts,
    isLoading,
  };
};
